<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
        <!-- 工单详情 -->
        <Detail ref="detailRef" v-show="showDetail" />
        <!-- 审核信息 -->
        <!-- <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item label="审核意见" prop="audit">
              <a-radio-group v-model="model.audit">
                <a-radio :value="1">通过</a-radio>
                <a-radio :value="0">驳回</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="备注" prop="remark">
              <a-textarea v-model="model.remark" placeholder="请输入备注信息" :rows="4" />
            </a-form-model-item>
          </a-col>
        </a-row> -->
        <!-- 勘察信息 -->

        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-model-item :label="$t('勘察相约时间')" prop="investigationDetail.investigationMeetTime">
              <a-date-picker
                show-time
                :placeholder="$t('请选择勘察相约时间')"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                v-model="model.investigationDetail.investigationMeetTime"
                style="width: 100%"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('勘察实际时间')" prop="investigationDetail.investigationActualTime">
              <a-date-picker
                show-time
                :placeholder="$t('请选择勘察实际时间')"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                v-model="model.investigationDetail.investigationActualTime"
                style="width: 100%"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('安全状况')" prop="investigationDetail.securityPosture">
              <a-select v-model="model.investigationDetail.securityPosture" :placeholder="$t('请选择安全状况')">
                <a-select-option :value="0">{{ $t('正常') }}</a-select-option>
                <a-select-option :value="1">{{ $t('恶劣') }}</a-select-option>
                <a-select-option :value="2">{{ $t('极度恶劣') }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-model-item :label="$t('施工环境')" prop="investigationDetail.constructionEnvironment">
              <!-- <a-input v-model="model.constructionEnvironment" placeholder="请输入施工环境"  ></a-input> -->
              <el-input
                type="text"
                size="small"
                v-model.trim="model.investigationDetail.constructionEnvironment"
                :placeholder="$t('请输入施工环境')"
                maxlength="20"
                show-word-limit
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('日供水量(m³)')" prop="investigationDetail.dailyWaterSupply">
              <a-input-number
                v-model="model.investigationDetail.dailyWaterSupply"
                :placeholder="$t('请输入日供水量')"
                style="width: 100%"
              />
            </a-form-model-item>
          </a-col>
          <!-- 只有新装时 才有 是否个人施工 -->
          <!-- <a-col :span="8" v-if="[1, 6].includes(ticketsData.ticketsType)">
            <a-form-model-item label="是否个人施工" prop="ifPersonalDeal">
              <a-radio-group v-model="model.ifPersonalDeal">
                <a-radio :value="0">否</a-radio>
                <a-radio :value="1">是</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col> -->
        </a-row>
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item :label="$t('备注')" prop="investigationDetail.remark">
              <a-textarea v-model="model.investigationDetail.remark" :placeholder="$t('请输入备注')" :rows="4" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="16">
            <a-form-model-item :label="$t('图片')" prop="investigationDetail.picture">
              <j-image-upload
                class="avatar-uploader"
                :text="$t('上传')"
                :isMultiple="true"
                v-model="model.investigationDetail.picture"
              ></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('附件')" prop="annex">
              <JUpload v-model="fileList" accept=".pdf,.doc,.docx,.xls,.xlsx" @change="uploadChange" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <!-- <a-col :span="24">
          <a-form-model-item label="下一节点操作人" prop="candidateUsers">
            <a-select mode="multiple" placeholder="请选择操作人" v-model="model.candidateUsers">
              <a-select-option :value="item.userName" v-for="item in candidateUsersList">{{item.userRealname}}</a-select-option>
            </a-select> 
          </a-form-model-item>
        </a-col> -->
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
import JImageUpload from '@/components/jeecg/JImageUpload.vue'
import JUpload from '@/components/jeecg/JUpload'
import DetailList from '@/components/tools/DetailList'
const DetailListItem = DetailList.Item
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import Detail from '../detail'

export default {
  name: 'ConstructionDetailForm',
  components: {
    JImageUpload,
    JUpload,
    DetailList,
    DetailListItem,
    Detail,
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      model: {
        // ifPersonalDeal: undefined,
      },
      confirmLoading: false,
      showDetail: false,
      url: {
        add: '/jeecg-engineering/engineering/investigationDetail/add',
        edit: '/jeecg-engineering/engineering/investigationDetail/edit',
        queryById: '/jeecg-engineering/ticket/tickets/queryById',
        pass: '/jeecg-engineering/flowable/task/completeByDateId',
        list: '/jeecg-engineering/engineering/investigationDetail/list',
        next: '/jeecg-engineering/flowable/task/completeByDateId',
        reject: '/jeecg-engineering/flowable/task/taskRejectByDataId',
        upload: 'sys/common/upload',
        // userList: "/jeecg-engineering/flowable/definition/userList",
        userList: '/jeecg-engineering/ticket/ticketsUser/list',
        editApproverName: '/jeecg-engineering/ticket/tickets/editApproverName',
        getNodeDetail: '/jeecg-engineering/engineering/installationDetail/getNodeDetail',
        userType: '/jeecg-charge/meter/meterUserType/list',
      },
      fileList: [],
      candidateUsersList: [],
      ticketsData: {},
      bool: false,
    }
  },
  computed: {
    formDisabled() {
      return this.disabled
    },
    validatorRules() {
      return {
        'investigationDetail.audit': { required: true, message: this.$t('请选择审批意见'), trigger: 'change' },
        'investigationDetail.remark': { required: true, message: this.$t('请输入备注'), trigger: ['blur', 'input'] },
        'investigationDetail.investigationMeetTime': [{ required: true, message: this.$t('请选择勘察相约时间') }],
        'investigationDetail.candidateUsers': { required: true, message: this.$t('请选择下一节点操作人'), trigger: 'change' },
        'investigationDetail.securityPosture': { required: true, message: this.$t('请选择安全状况'), trigger: 'change' },
        // ifPersonalDeal: { required: true, message: '请选择是否个人施工', trigger: ['blur', 'change'] },
        // annex:{ required: true,message: '请选择附件', trigger: 'change' }
      }
    },
  },
  watch: {
    'model.audit': {
      handler(val) {
        if (val == 1) {
          this.validatorRules.remark.required = false
        } else {
          this.validatorRules.remark.required = true
        }
      },
    },
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
  },
  methods: {
    getUserList() {
      getAction(this.url.userList, { pageSize: 999 }).then(res => {
        if (res.success) {
          this.candidateUsersList = res.result.records
        }
      })
    },
    uploadChange(file) {
      // this.model.annex = file;
      this.$set(this.model.investigationDetail, 'annex', file)
      this.$nextTick(() => {
        this.$refs.form.validateField('annex')
      })
    },
    // handleChange(info){
    //   const { fileList } = this;
    //   const formData = new FormData();
    //   fileList.forEach(file => {
    //     formData.append('file', file);
    //     formData.append('biz', 'temp');
    //   });
    //   postAction(this.url.upload,formData).then(res=>{
    //     if(res.success){
    //       this.model.annex = res.message;
    //     }
    //   });
    // },
    // beforeUpload (file) {
    //   this.fileList = [file];
    //   this.model.annexName = this.fileList[0].name;
    //   return false;
    // },
    // handleRemove (file) {
    //   const index = this.fileList.indexOf(file);
    //   const newFileList = this.fileList.slice();
    //   newFileList.splice(index, 1);
    //   this.fileList = newFileList;
    // },
    add() {
      this.edit(this.modelDefault)
    },
    edit(record, bool) {
      let that = this
      this.model = Object.assign({})
      // 清除表单验证
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })

      if (record.id) {
        // 获取详情信息
        getAction(this.url.queryById, { id: record.id }).then(res => {
          if (res.success) {
            that.ticketsData = { ...res.result }
            // 报装 勘察信息
            that.model = {
              ...res.result.installationDetail,
              // dataId:  res.result.id,
              // installationId:  res.result.ticketsForeignId,
              // ticketsId:  res.result.id,
            }
            // 确保子组件已挂载
            that.$nextTick(() => {
              if (that.$refs.detailRef) {
                that.$refs.detailRef.init(that.ticketsData, bool)
                that.showDetail = true
              } else {
                console.error('子组件引用不存在')
              }
            })
          }
        })
      }
      this.visible = true
    },
    submitForm() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = this.url.pass
          let method = 'post'
          let message = this.$t('处理成功')

          let params = {
            dataId: that.ticketsData.id,
            createTicketDTO: {
              ticketsInstallationReq: {
                ...that.model,
              },
            },
            comment: '',
          }

          httpAction(httpurl, params, method)
            .then(res => {
              if (res.success) {
                that.$message.success(message)
                that.$emit('ok')
                this.visible = false
              } else {
                that.$message.warning(res.message)
              }
              that.confirmLoading = false
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
  },
}
</script>
<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}
</style>
